import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useUpgradeAllyMutation } from '@http';
import { Modal } from '@components/ui/Modal';
import { useAppStore } from '@stores';
import * as Shared from '@shared/lib';

interface UpgradeAllyProps {
  allyId: string;
  onClose: () => void;
};

export function UpgradeAlly({ allyId, onClose }: UpgradeAllyProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Hub.Allies' });
  const { mutateAsync } = useUpgradeAllyMutation();
  const { userData, refetch, setIsFetching } = useAppStore();

  const ally = userData.allies.find((ally) => ally.id === allyId);
  if (!ally) return null;

  const level = Shared.AllyLevelCalculator.calc(ally.xp, ally.rank);
  const canUpgrade = level.current >= 30 && ally.rank < 5;

  const upgrade = async () => {
    setIsFetching(true);
    await mutateAsync({ id: allyId });
    refetch();
    onClose();
  };

  return (
    <Modal title={t('upgradeModal')} onRequestClose={onClose} isOpen={!!allyId}>
      {!canUpgrade && (
        <p className="text-center text-sm text-gray-400 my-4 px-2">
          {t(ally.rank >= 5 ? 'maxDescription' : 'cantUpgrade')}
        </p>
      )}

      {canUpgrade && (
        <>
          <p className="text-center text-sm text-shield mt-4 px-2">
            {t('upgradeDescription')}
          </p>

          <Button className="mt-4 border-0 border-t" onClick={upgrade}>
            {t('upgrade')}
          </Button>
        </>
      )}
    </Modal>
  );
}